import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ActivatedRoute } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { Analytics } from '@shared/entities/analytics/analytics';

@Injectable({
  providedIn: 'root'
})
export class FilterInformationsService extends ApiService<Analytics> {
  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/analytics?query=filter-info';
    const detailUrl = '/analytics?query=filter-info';

    super(Analytics, masterUrl, detailUrl);
  }

  getFilterValues(fields: string[], filter: any, limit?: string): Observable<any> {
    if (limit) {
      this.setUrlParameter('limit', limit);
    }

    if (fields.length > 0) {
      this.setUrlParameter('fields', fields.join(','));
    }

    if (filter) {
      this.setUrlParameter('value', filter.value);
    }

    return this.findOne('').pipe(
      map((response) => response.rows || {}),
      catchError((error) => {
        console.error('Error fetching filter values', error);
        return of([]);
      })
    );
  }
}
